module.exports = __webpack_public_path__ + "static/media/loginRegisterBackground.d2f0d037.png";